exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".s-upload-preview .el-upload{width:100%;height:100%}.s-upload-preview__item .el-upload-dragger{display:flex;align-items:center;justify-content:center;width:100%;height:100%;border:none;background:transparent}.s-upload-preview .el-upload--text{width:100%;height:100%}.s-upload-trigger__inner{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:100%;padding:8px;color:#97a8be}.s-upload-trigger__inner .el-icon-upload{margin:0 0 6px;font-size:28px;line-height:1}.s-upload-trigger__inner .s-upload-default__text{padding:0 8px;color:#97a8be;font-size:12px;line-height:1.4;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-9319504c!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/common/SUpload.vue
// module id = 605
// module chunks = 0